import { render, staticRenderFns } from "./createOrganization.vue?vue&type=template&id=3a660e5a&"
import script from "./createOrganization.vue?vue&type=script&lang=js&"
export * from "./createOrganization.vue?vue&type=script&lang=js&"
import style0 from "./createOrganization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports